export const RESISTANCE_DAMAGE_TYPES = Object.freeze(['acid','bludgeoning','cold','fire','lightning','necrotic','piercing','poison','radiant','slashing','thunder']);
